import { createRouter, createWebHistory } from "vue-router";
import Service from "../views/Service.vue";
import HomeView from "../views/HomeView.vue";
import Training from "../views/Training.vue";
import AboutView from "../views/AboutView.vue"
import SpaceView from "../views/SpaceView.vue"


const routes = [{
        path: "/",
        name: "home",
        component: HomeView,
    },
    {
        path: "/service",
        name: "service",
        component: Service,
    },
    {
        path: "/training",
        name: "training",
        component: Training,
    },
    {
        path: "/about",
        name: "about",
        component: AboutView
    },
    {
     
        
         path: "/co-workspace",
         name: "SpaceView",
         component: SpaceView
        
                
    },
    {
        path: '/product',
        name: 'product',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import ( /* webpackChunkName: "about" */ '../views/ProductView.vue')
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

export default router;